import React from 'react'
import { LineChart } from '@components/charts/LineChart'

import { buildLineChartDataProp } from './charts/data'
import { buildLineChartOptionsProp } from './charts/options'

interface ChartData {
  labels: string[]
  datasets: object
}

interface FinancialHealthLineChartProps {
  height?: string
  chartData: ChartData
  benchmark: number
}

const FinancialHealthLineChart: React.FC<FinancialHealthLineChartProps> = ({ height = "medium", chartData, benchmark }) => {
  const datasets = buildLineChartDataProp(chartData.datasets, benchmark)
  const options = buildLineChartOptionsProp()

  return (
    <LineChart
      height={height}
      labels={chartData.labels}
      datasets={datasets}
      options={options}
    />
  )
}

export default FinancialHealthLineChart
